// extracted by mini-css-extract-plugin
export var colorSquare = "_si-0";
export var danger = "_si-5";
export var lightPink = "_si-8";
export var neutralBlue = "_si-7";
export var neutralYellow = "_si-6";
export var normal = "_si-1";
export var primary = "_si-2";
export var primaryLight = "_si-3";
export var solidBlack = "_si-g";
export var solidGreen = "_si-b";
export var solidLightBlue = "_si-d";
export var solidNavy = "_si-c";
export var solidOrange = "_si-f";
export var solidPink = "_si-e";
export var solidRed = "_si-9";
export var solidYellow = "_si-a";
export var success = "_si-4";